export function getCmDriverStartEnd(booking) {
  if (!booking || booking.status === 'cancelled')
    return { start: null, end: null, timeKind: 'planned' }

  const actual = booking.actual || {}
  const actualStart = actual.nearestLoginStartDateTime
  const actualEnd = actual.nearestLogoutFinishDateTime
  if (actualStart && actualEnd)
    return { start: actualStart, end: actualEnd, timeKind: 'actual' }

  const plannedStart = actual.plannedStartDateTime || booking.start_datetime
  const plannedEnd = actual.plannedFinishDateTime || booking.finish_datetime
  if (plannedStart && plannedEnd)
    return { start: plannedStart, end: plannedEnd, timeKind: 'planned' }

  return { start: null, end: null, timeKind: 'planned' }
}

export function getTbnDriverStartEnd(booking) {
  if (!booking || booking.status === 'cancelled')
    return { start: null, end: null, timeKind: 'planned' }

  const actual = booking.actual || {}
  const actualStart = actual.actualClockInTime
  const actualEnd = actual.actualClockOutTime
  if (actualStart && actualEnd)
    return { start: actualStart, end: actualEnd, timeKind: 'actual' }

  const plannedStart = booking.start_datetime
  const plannedEnd = booking.finish_datetime
  if (plannedStart && plannedEnd)
    return { start: plannedStart, end: plannedEnd, timeKind: 'planned' }

  return { start: null, end: null, timeKind: 'planned' }
}

import { excludeSkippedUnlessSelected } from '@/helpers/actuals_status_filter'

export function filterActualsByStatus(items, selectedStatus, overlapKey) {
  if (!items)
    return []
  const visible = excludeSkippedUnlessSelected(items, selectedStatus)
  if (selectedStatus == null)
    return visible
  if (selectedStatus === overlapKey)
    return visible.filter(item => item[overlapKey])
  return visible.filter(item => item.status === selectedStatus)
}

export function filterDriverActualsByStatus(items, selectedStatus) {
  return filterActualsByStatus(items, selectedStatus, 'driver_overlap')
}
